import React from "react";
import Navbar from "../Navbar/Navbar";
import NavbarD from "../Navbar/NavbarD";
import { useState } from "react";
import { useEffect } from "react";
import dataEn from "../../../languages/en/firstSec";
import dataTh from "../../../languages/th/firstSec";

const FirstSection = ({ language }) => {
  const background1 = process.env.PUBLIC_URL + "/mian/bg/hero-section.png";
  const background2 = process.env.PUBLIC_URL + "/mian/bg/mobile_bg.jpg";
  const laptop = process.env.PUBLIC_URL + "/mian/bg/mobile_laptop.png";
  const data = language === "en" ? dataEn : dataTh;

  const [backgroundImage, setBackgroundImage] = useState(background1);
  const sectionStyles = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "center",
    backgroundPosition: "bottom",
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        // You can adjust this breakpoint according to your needs
        setBackgroundImage(background2);
      } else {
        setBackgroundImage(background1);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize the background image based on initial screen size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <section
        className={` bg-cover md:bg-cover
            bg-bottom text-white h-400 md:h-550 mmd:h-600 mlg:h-700 lg:h-700 xl:h-750 xxl:h-800
                relative
            `}
        style={sectionStyles}
      >
        <div className="lg:hidden ">
          <Navbar />
        </div>
        <div className="hidden md:hidden lg:block ">
          <NavbarD />
        </div>
        <h1
          className="font-prompt text-base font-medium md:text-2xl lg:text-5xl leading-130 text-white mt-8 mb-4"
          style={{
            color: "#FFF",
            textAlign: "center",
          }}
        >
          {data.title1}
          <span style={{ color: "#F00" }}> {data.title2} </span> {data.title3}
          <br />
          {data.title4}
        </h1>
        <p className="font-prompt text-xs md:text-sm leading-164 text-white mb-8 text-center">
          {data.desc1}
          <span className="block md:inline lg:inline">
            {data.desc2}{" "}
            <span className="inline md:block lg:inline">
              {data.desc3}{" "}
              <span className="block md:inline lg:block">
                {data.desc4}{" "}
                <span className="block md:inline">{data.desc5}</span>
              </span>
            </span>
          </span>
        </p>

        {window.innerWidth < 768 && (
          <div
            className="absolute  md:hidden top-72 w-full z-20
        "
          >
            <img
              className="
            w-72  flex justify-center mx-auto
          "
              src={laptop}
              alt="mobile"
            />
          </div>
        )}
      </section>
    </>
  );
};

export default FirstSection;
